"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var VButton_vue_1 = __importDefault(require("./VButton.vue"));
var VModal_vue_1 = __importDefault(require("./VModal.vue"));
var __ = window.$lang;
exports.default = vue_1.default.extend({
    name: "v-confirmation-modal",
    components: {
        VButton: VButton_vue_1.default,
        VModal: VModal_vue_1.default
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: __("Potwierdź akcję")
        },
        question: {
            type: String,
            default: __("Czy na pewno chcesz wykonać tę akcję?")
        },
        okTitle: {
            type: String,
            default: __("Tak")
        },
        okColor: {
            type: String,
            default: "success"
        },
        okIcon: {
            type: String,
            default: "fas fa-check"
        },
        cancelTitle: {
            type: String,
            default: __("Anuluj")
        },
        cancelColor: {
            type: String,
            default: "white"
        },
        cancelIcon: {
            type: String,
            default: "fas fa-times"
        },
    },
    methods: {
        onCancel: function () {
            this.$emit("cancel");
        }
    }
});
